<template>
	 <div class='d-flex align-items-center justify-content-between neue' :class="{ 'mb32': isMobile, 'mb16': !isMobile }">
		<Icon v-if="isMobile" name="arrow-left" class="c24 pointer" @click="close" />
		<h4 class="fsp20 lh28 neue mb-0" :class="{ 'text-center mr24 flex-grow-1': isMobile }">{{ $t('views.Payin.26') }}</h4>
		<Icon v-if="!isMobile" name="close" class="c24 pointer" @click="close" />
	</div>
	<div class='bg-white rounded12' :class="{ 'p24': !isMobile }">
		<div>
			<label class="fsp14 lh20 neue-roman mb8">{{ $t('views.Payin.3') }} </label>
			<InputSimple
				id="template_name"
				:dataValue="data.template_name"
				@updateParentState="updateState"
			/>
		</div>
		<div class="d-flex gap-3 mt24" :class="{ 'position-fixed bottom-0 left-0 end-0 bg-white py16 px24 border-t w-100': isMobile }">
			<Button 
				class="h48 equal-width"
				:name="$t('views.Payin.4')" 
				@click="saveTemplate" 
				type='btn-warning' 
				:disabled='!data.template_name'
			/>
			<Button
				class="h48 equal-width"
				:name="$t('views.Payin.27')" 
				@click="close" 
				type='btn-outline-grey' 
			/>
		</div>
	</div>
</template>

<script>
import Icon from '@/components/icons/Icon';
import InputSimple from '@/components/service/InputSimple';
import Button from '@/components/service/Button';

export default {
	components: {
		Icon,
		InputSimple,
		Button
	},
	props: {
		close: [Function],
	},
	data() {
		return {
			content: this.$store.state.modal.content,
			callback: this.$store.state.modal.content.callback,
			data: {
				template_name: '',
			},
		}
	},
	computed: {
		isMobile() {
			return this.$store.state.resize.w <= 768;
		},
	},
	methods: {
		saveTemplate() {
			this.callback(this.data.template_name);
			this.close();
		},
		updateState(state) {
			this.data[state.id] = state.value;
		},
	},
}
</script>